import { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DownArrow from "../../../../../assets/pictures/icons/down-arrow-iocn.svg";
import { changeFormData } from "../../../../../redux/slices";
import type { IRootState } from "../../../../../redux/store";
import type { TGenderRu, VoiceItemTypes, VoiceTypes } from "../../../../../utils/types";
import renderDropList from "./DropList";
import style from "./NewVoice.module.scss";
import { filterVoicesByGender, mapVoicesToDropItems } from "../../../../../utils/sharedVoices";
import { useMediaPreview } from "../../../../PreviewAvatarMedia/MediaPreviewProvider";

const NewVoice = () => {
	const dispatch = useDispatch();
	const currentAvatarGender =
		useSelector((state: IRootState) => state.avatar.gender) || "male";
	const gender: TGenderRu =
		currentAvatarGender === "male" ? "Мужской" : "Женский";
	const { setVideoState } = useMediaPreview();

	const formData = useSelector((state: IRootState) => state.avatarForm);
	const availableVoices = useSelector((state: IRootState) => state.voicesList);
	const genderVoices: VoiceTypes[] = useMemo(
		() =>
			filterVoicesByGender(availableVoices, currentAvatarGender),
		[availableVoices, currentAvatarGender],
	);

	const [openedDrop, setOpenedDrop] = useState<"voice" | "none">("voice");

	const changeVoice = useCallback(
		(voice: string) => {
			dispatch(changeFormData({ voice }));
			setVideoState("playing");
		},
		[dispatch],
	);

	const voiceListItems: VoiceItemTypes[] = useMemo(
		() =>
			mapVoicesToDropItems(genderVoices, changeVoice),
		[genderVoices],
	);
	
	const toggleDropdown = useCallback(() => {
		setOpenedDrop((prev) => (prev === "voice" ? "none" : "voice"));
	}, []);

	return (
			<div className={style.containerVoice}>
				<h5>Голос</h5>
				<div className={style.container}>
					<div
						onClick={toggleDropdown}
						className={`${style.containerDrop}`}
					>
						<div
							className={`${style.input} ${openedDrop === "voice" && style.active} ${
								style.selected
							}`}
						>
							<span>{gender}</span>
							<img
								src={DownArrow}
								alt="down arrow"
								className={`${style.arrow} ${openedDrop === "voice" ? style.rotate : ""}`}
							/>
						</div>
					</div>
				</div>
				{openedDrop !== "none" &&
					renderDropList({
						selected: formData.voice,
						onClick: changeVoice,
						items: voiceListItems,
				})}
			</div>
	);
};

export default NewVoice;
